import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import { connectModal } from "redux-modal";
import {
  ControlGroup,
  Button,
  Modal,
  ModalContent,
  ModalFooter,
} from "@conserveit/blocks";
import { EditUserForm } from "../../../components";

export const EDIT_USER_MODAL = "EDIT_USER_MODAL";

class EditUserModal extends PureComponent {
  static propTypes = {
    title: PropTypes.string.isRequired,
    submitText: PropTypes.string.isRequired,
    error: PropTypes.string,
    show: PropTypes.bool.isRequired,
    disabled: PropTypes.bool,
    toggleDeactivateWorking: PropTypes.bool,
    user: PropTypes.object,
    userFormData: PropTypes.object.isRequired,
    usersLookup: PropTypes.array.isRequired,
    groups: PropTypes.array.isRequired,
    rolesSelectOptions: PropTypes.array.isRequired,
    handleClose: PropTypes.func.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    handleChange: PropTypes.func.isRequired,
    submitFunc: PropTypes.func.isRequired,
    toggleSubUser: PropTypes.func,
    handleToggleDeactivate: PropTypes.func.isRequired,
  };

  render() {
    const {
      title,
      show,
      handleClose,
      error,
      disabled,
      submitText,
      userFormData,
      usersLookup,
      handleChange,
      handleSubmit,
      toggleSubUser,
      submitFunc,
      handleToggleDeactivate,
      toggleDeactivateWorking,
      user,
      groups,
      rolesSelectOptions,
    } = this.props;
    return (
      <Modal isOpen={show} onRequestClose={handleClose} title={title}>
        <ModalContent>
          <EditUserForm
            formData={userFormData}
            userOptions={usersLookup}
            onChange={handleChange}
            error={error}
            disabled={disabled}
            toggleSubUser={toggleSubUser}
            handleToggleDeactivate={handleToggleDeactivate}
            toggleDeactivateWorking={toggleDeactivateWorking}
            user={user}
            groupOptions={groups}
            rolesSelectOptions={rolesSelectOptions}
          />
        </ModalContent>
        <ModalFooter>
          <ControlGroup tight>
            <Button
              data-cy="UserAdmin-cancelEditUser"
              thin
              appearance="outline"
              onClick={handleClose}
            >
              Cancel
            </Button>
            <Button
              data-cy="UserAdmin-editUser"
              thin
              primary
              onClick={() => handleSubmit(submitFunc)}
            >
              {submitText}
            </Button>
          </ControlGroup>
        </ModalFooter>
      </Modal>
    );
  }
}

const ConnectedEditUserModal = connectModal({
  name: EDIT_USER_MODAL,
  getModalState: (state) => state.betaModal,
})(EditUserModal);

export default ConnectedEditUserModal;
